import { render, staticRenderFns } from "./OrderServiceTotalization.vue?vue&type=template&id=71b0b344&"
import script from "./OrderServiceTotalization.vue?vue&type=script&lang=js&"
export * from "./OrderServiceTotalization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports